import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import LockOutlined from '@material-ui/icons/LockOutlined';
import grey from '@material-ui/core/colors/grey';
import FormControl from '@material-ui/core/FormControl';
import { Field, reduxForm } from 'redux-form'

const primaryGrey = grey[600]; // #F44336

const validate = values => {
  const errors = {};

  const requiredFields = [
    'new_password',
    'confirm_password'
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  })

  if (values.new_password !== values.confirm_password) {
    errors.new_password = 'La contraseña no coincide'
    errors.confirm_password = 'La contraseña no coincide'
  }

  return errors
}

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth margin='dense'>
      <TextField
        multiline={input.name === 'description'}
        rows={5}
        placeholder={label}
        error={touched && typeof error !== 'undefined'}
        helperText={(touched && typeof error !== 'undefined') ? error : null}
        {...input}
        {...custom}
      />
    </FormControl>
  )
}

class ChangePasswordForm extends React.PureComponent {


  render() {
    const { handleSubmit, pristine, submitting, showCancelBtn } = this.props;

    return (
      <form onSubmit={handleSubmit}>

        <Grid container spacing={8} alignItems="flex-end">
          <Grid item xs={1}>
            <LockOutlined style={{color: primaryGrey}} />
          </Grid>
          <Grid item xs={11}>
            <div style={{paddingLeft: 5}}>
              <Field name="new_password" component={renderTextField} label='Contraseña' type="password" />
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={8} alignItems="flex-end">
          <Grid item xs={1}>
            <LockOutlined style={{color: primaryGrey}} />
          </Grid>
          <Grid item xs={11}>
            <div style={{paddingLeft: 5}}>
              <Field name="confirm_password" component={renderTextField} label='Repite la contraseña' type="password" />
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={8} style={{marginTop: '10%'}}>
          {showCancelBtn &&
          <Grid item xs={6} align="center">
            <Button type="submit" variant="flat" component={Link} to="/auth/login">
              Cancelar
            </Button>
          </Grid>
          }

          <Grid item xs={showCancelBtn ? 6 : 12} align="center">
            <Button type="submit" variant="contained" color="primary" disabled={pristine || submitting}>
              Guardar
            </Button>
          </Grid>

        </Grid>

      </form>
    )
  }
}

ChangePasswordForm = reduxForm({
  form: 'changePassword',
  validate
})(ChangePasswordForm)

ChangePasswordForm = connect(state => ({
  auth: state.auth
}))(ChangePasswordForm)


export default ChangePasswordForm;



// WEBPACK FOOTER //
// ./src/modules/auth/forms/ChangePasswordForm.js